<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XeJK5y/tc-custom/9781620100431.jpg?1728155712582" alt="This image is the cover for the book Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scott Pilgrim Vol. 1: Precious Little Life, Scott Pilgrim
      </h1>
      <p class="bookDescription body article font2">
        <p>Just when you thought you knew all there was to know about SCOTT PILGRIM comes SCOTT PILGRIM COLOR Hardcover VOLUME 1: PRECIOUS LITTLE LIFE! The first in a series of brand-new Hardcover editions, this remastered, 6”x9” Hardcover presents Scott’s first “evil ex” battle as you’ve never seen it before—in full-color! Plus, previously unpublished extras and bonus materials make this mighty tome one that’s required reading for Scottaholics everywhere!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryan Lee O'Malley
      </h2>
      
      <p class="authorDescription body article">Bryan Lee O'Malley is a Canadian cartoonist. His award-winning Scott Pilgrim series (2004-2010) was a New York Times best seller and the basis for the 2010 Universal film Scott Pilgrim Vs the World. In 2023, he co-wrote and co-produced the Netflix animated series Scott Pilgrim Takes Off. His books, including Lost at Sea, Seconds, and Snotgirl, have been translated into over twenty languages. He lives in Los Angeles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9bb1b498